export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12325.385585e4.jpg";